module.exports = __webpack_public_path__ + "static/img/wispPediatricNasalMask.963a3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/wispPediatricNasalMask.png
// module id = DIoi
// module chunks = 1